export enum PageName {
  /**
   * 首页
   */
  HOME = 0,
  /**
   * 煤炭专区
   */
  COAL_ZONE = 1,
  /**
   * 化工专区
   */
  CHEMICAL_ZONE = 2,
  /**
   * 行业资讯
   */
  NEWS = 3
}

export const PageNameTextMap: Record<PageName, string> = {
  [PageName.HOME]: '首页',
  [PageName.COAL_ZONE]: '煤炭专区',
  [PageName.CHEMICAL_ZONE]: '化工专区',
  [PageName.NEWS]: '行业资讯'
}
